export default "__VITE_ASSET__BIxY2gv2__"